<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <v-card>
          <v-card-title>
            <h1 class="headline mb-1">Planes</h1>
            <v-spacer></v-spacer>
            <v-text-field 
                v-model="search"
                append-icon="search"
                label="Buscar"
                single-line
                hide-details>
            </v-text-field>
            <v-spacer></v-spacer>
            <v-btn color="primary" class="mb-2"  @click="crearPlan">Crear</v-btn>
          </v-card-title>
          <v-data-table 
            :headers="headers"
            :items="array_obj"
            :items-per-page="10"
            loading-text="Cargando..."
            no-data-text="No hay registros a mostrar"
            :search="search"
            :footer-props="{
              itemsPerPageOptions: [5, 10, 20, 50, 100],
              showFirstLastPage: true,
              firstIcon: 'mdi-arrow-collapse-left',
              lastIcon: 'mdi-arrow-collapse-right',
              prevIcon: 'mdi-minus',
              nextIcon: 'mdi-plus',
              itemsPerPageText:'Registros por página'
            }"
            class="elevation-1">
            <template v-slot:[`item.action`]="{ item }">
              <v-btn fab x-small @click="editar(item)" class="mr-2">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
              <v-btn fab x-small class="mr-2" @click="dialog=true;selected_id=item.id;">
                <v-icon>mdi-close-thick</v-icon>
              </v-btn>
            </template>
            <template v-slot:[`item.estado`]="{ item }">
                <v-chip v-if="item.estado == 'ACTIVO'" x-small color="success" text-color="white"> Activo </v-chip>
                <v-chip v-else x-small color="red" text-color="white"> Inactivo </v-chip>
            </template>
          </v-data-table>
        </v-card>

        <template>
          <v-row justify="center">
            <v-dialog v-model="dialog" persistent max-width="290">
              <v-card>
                <v-card-title class="headline"></v-card-title>
                <v-card-text>Desea eliminar el item {{selected_id}}?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click="dialog = false;">No</v-btn>
                    <v-btn color="green darken-1" text @click="dialog = false;eliminar();  ">Si</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-row>
        </template>
        <v-dialog v-model="dialogForm" persistent max-width="800px">
          <v-card>
            <v-card-title class="headline">
              <span v-if="es_nueva">Nuevo Plan</span>  
              <span v-if="!es_nueva">Editar Plan</span>  
            </v-card-title>
            <v-card-text>
              <v-form ref="form" v-model="valid" lazy-validation>

              <v-row>
                <v-col cols="12" md="12">
                  <v-text-field 
                    v-model="nombre" 
                    class="mt-0 pt-0"
                    :rules="[rules.required]"
                    label="Nombre">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="codigo_esb" 
                    type="number"
                    class="mt-0 pt-0"
                    :rules="[rules.required]"
                    label="Código Esb">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="contrato_anual" 
                    type="number"
                    class="mt-0 pt-0"
                    :rules="[rules.required]"
                    label="Contrato Anual">
                  </v-text-field>
                </v-col>
                <!--<v-col cols="12" md="4">
                  <v-text-field 
                    v-model="contrato_mensual" 
                    class="mt-0 pt-0"
                    type="number"
                    :rules="[rules.required]"
                    label="Contrato Mensual">
                  </v-text-field>
                </v-col>
              -->
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="capacitaciones" 
                    type="number"
                    class="mt-0 pt-0" 
                    :min = "0" 
                    :rules="[rules.positivo_mayor_cero]"
                    label="Capacitaciones">
                  </v-text-field>
                </v-col>
              </v-row>

              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="certificados" 
                    class="mt-0 pt-0"
                    type="number"
                    :min = "0" 
                    :rules="[rules.positivo_mayor_cero]"
                    label="Certificados">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="administradores" 
                    type="number"
                    class="mt-0 pt-0"
                    :min = "0" 
                    :rules="[rules.positivo_mayor_cero]"
                    label="Administradores">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="operadores" 
                    class="mt-0 pt-0"
                    type="number"
                    :min = "0" 
                    :rules="[rules.positivo_mayor_cero]"
                    label="Operadores">
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="estampado_anual" 
                    type="number"
                    class="mt-0 pt-0"
                    :rules="[rules.required]"
                    label="Estampado anual">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="documentos_resguardados" 
                    class="mt-0 pt-0"
                    type="number"
                    :rules="[rules.required]"
                    label="Doc Resguardados">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="tamano_documentos" 
                    type="number"
                    class="mt-0 pt-0"
                    :rules="[rules.required]"
                    label="Tamaño Documentos(MB)">
                  </v-text-field>
                </v-col>
              </v-row>              

            
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="tiempo_resguardo" 
                    class="mt-0 pt-0"
                    type="number"
                    :rules="[rules.required]"
                    label="Tiempo Resguardo(dias)">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="espacio_disponible" 
                    type="number"
                    class="mt-0 pt-0"
                    :min = "0" 
                    :rules="[rules.positivo_mayor_cero]"
                    label="Espacio Disponible(GB)">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="flujos" 
                    class="mt-0 pt-0"
                    type="number"
                    :min = "0" 
                    :rules="[rules.positivo_mayor_cero]"
                    label="Flujos">
                  </v-text-field>
                </v-col>                
              </v-row>  
              <v-row>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="correos" 
                    type="number"
                    class="mt-0 pt-0"
                    :min = "0" 
                    :rules="[rules.positivo_mayor_cero]"
                    label="Correos">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-text-field 
                    v-model="plantillas" 
                    type="number"
                    class="mt-0 pt-0"
                    :min = "0" 
                    :rules="[rules.positivo_mayor_cero]"
                    label="Plantillas">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="4">
                  <v-radio-group v-model="estado"  column>
                    <v-radio label="Activo" value="ACTIVO"></v-radio>
                    <v-radio label="Inactivo" value="INACTIVO"></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>  
              <v-row>
                <v-col cols="12" md="3">
                  <v-switch 
                    v-model="manuales"
                    label="Manuales">
                  </v-switch>
                </v-col>
                <v-col cols="12" md="3">
                  <v-switch 
                    v-model="proceso_lotes"
                    label="Proceso Lotes">
                  </v-switch>
                </v-col>
                <v-col cols="12" md="3">
                  <v-switch 
                    v-model="personalizacion"
                    label="Personalización">
                  </v-switch>
                </v-col>
                <v-col cols="12" md="3">
                  <v-switch 
                    v-model="estampados_ilimitados"
                    label="Ilimitado">
                  </v-switch>
                </v-col>
              </v-row>  
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="blue darken-1" text @click="reset"> Cerrar </v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!valid" v-if="es_nueva" color="primary" class="mr-4" type="submit" @click="validate_and_save"> Grabar </v-btn>
              <v-btn :disabled="!valid" v-if="!es_nueva" color="primary" class="mr-4" type="submit" @click="validate_and_update"> Actualizar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-col>
  </v-row>
</v-container>
</template>
<script>

  import axios from "axios";
  export default {
    data () {
      return {
        search: "",
        dialog: false,
        selected_id: 0,
        notificacion_exito: false,
        headers: [
          // { text: 'Id', align: 'start', sortable: true, value: 'id' },
          { text: 'Nombre', value: 'nombre', sortable: true },
          { text: 'Codigo Esb', value: 'codigo_esb', sortable: true },
          { text: 'Estampado', value: 'estampado_anual', sortable: true },
          { text: 'Contrato', value: 'contrato_anual', sortable: true },
          { text: 'Capacitaciones', value: 'capacitaciones', sortable: true },
          { text: 'Admin', value: 'administradores', sortable: true },
          { text: 'Operadores', value: 'operadores', sortable: true },
          { text: 'Plantillas', value: 'plantillas', sortable: true },
          { text: 'Correos', value: 'correos', sortable: true },
          { text: 'Tamaño (m)', value: 'tamano_documentos', sortable: true },
          { text: 'Flujos', value: 'flujos', sortable: true },
          { text: 'Espacio (gb)', value: 'espacio_disponible', sortable: true },
          { text: 'Estado', value: 'estado', sortable: true },
          { text: 'Acciones', value: 'action', sortable: false }
        ],
        array_obj: [],
        administradores: null,
        capacitaciones: null,
        certificados: null,
        contrato_anual: null,
        contrato_mensual:null,
        correos: null,
        codigo_esb: null,
        documentos_resguardados: null,
        espacio_disponible: null,
        estado: "ACTIVO",
        estampado_anual: null,
        fecha_actualizacion: null,
        fecha_alta: null,
        flujos: null,
        id: null,
        manuales: false,
        estampados_ilimitados: false,
        nombre: null,
        operadores: null,
        personalizacion: false,
        plantillas: null,
        proceso_lotes: false,
        tamano_documentos: null,
        tiempo_resguardo: null,
        usuario_actualizacion: null,
        usuario_creacion: null, 
        valid: true,
        es_nueva: true,
        dialogForm: false,
        rules: {
          required: value => !!value || 'Campo Requerido.',
          positivo_mayor_cero: value =>  0 <= Number(value) || 'Campo debe ser mayor a cero'
        },
      }
    },
    mounted() {
      console.log("parametros.vue");      
      this.getParametros();
    },
    methods: {
      eliminar() {
          console.log("Deleting Item id :" + this.selected_id)
          let getuser = axios.delete('Plan/eliminar/' + this.selected_id,  { 'headers': this.$store.state.user.headers })
          return getuser.then((callback) => {
            if(callback.status == 200) {
              console.log('Eliminando el item : ' + this.selected_id);
              this.array_obj.splice(this.array_obj.findIndex(e => e.id == this.selected_id), 1);
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
            } else {
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo error en el proceso' });
            }
          }).catch((error) => {
            console.log(error.response);
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Hubo error en el proceso' });
        });
      },
      getParametros() {
        let getParametros = axios.get('Plan/listar', { 'headers': this.$store.state.user.headers });
        return getParametros.then((callback) =>
        {
          this.array_obj = callback.data;
        }).catch((error) => {
          console.log("ERROR EN EL CALLBACK" + error);
        });
      },
      validate_and_save() {
        if (this.$refs.form.validate()) {
          this.dialogForm = false;
          this.$store.dispatch('SET_OVERLAY');

          let vm_data = {
            administradores: Number(this.administradores),
            capacitaciones: Number(this.capacitaciones),
            certificados: Number(this.certificados),
            contrato_anual: Number(this.contrato_anual),
            contrato_mensual:Number(this.contrato_mensual),
            correos: Number(this.correos),
            codigo_esb: this.codigo_esb,
            documentos_resguardados: Number(this.documentos_resguardados),
            espacio_disponible: Number(this.espacio_disponible),
            estado: this.estado,
            estampado_anual: Number(this.estampado_anual),
            flujos: Number(this.flujos),
            manuales: this.manuales,
            nombre: this.nombre,
            operadores: Number(this.operadores),
            personalizacion: this.personalizacion,
            plantillas: Number(this.plantillas),
            proceso_lotes: this.proceso_lotes,
            tamano_documentos: Number(this.tamano_documentos),
            tiempo_resguardo: Number(this.tiempo_resguardo),
            estampados_ilimitados: this.estampados_ilimitados
          };

          let getuser = axios.post('Plan/Crear', vm_data, { 'headers': this.$store.state.user.headers })
          return getuser.then((callback) => {
            console.log(callback);
            if(callback.status ==201) {
              this.reset();
              let getMembresias = axios.get('Plan/Recuperar/' + callback.data, { 'headers': this.$store.state.user.headers });
              return getMembresias.then((callback1) =>
              {                
                if(callback1.status == 200) {
                  this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
                  this.array_obj.push(callback1.data);
                  this.$store.dispatch('UNSET_OVERLAY');
                }
              }).catch((error) => {
                this.dialogForm = true;
                this.$store.dispatch('UNSET_OVERLAY');
                console.log(error.response.data);
                this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operacion 1: ' + error.response.data });
              });
            }
          }).catch((error1) => {
            this.dialogForm = true;
            console.log(error1.response.data);
            this.$store.dispatch('UNSET_OVERLAY');
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operacion 2: ' + error1.response.statusText });
          });
        }
      },
      validate_and_update() {
        console.log("validate_and_update");
        if (this.$refs.form.validate()) {
          this.$store.dispatch('SET_OVERLAY');
          this.dialogForm = false;

          let vm_data = {
            administradores: Number(this.administradores),
            capacitaciones: Number(this.capacitaciones),
            certificados: Number(this.certificados),
            contrato_anual: Number(this.contrato_anual),
            contrato_mensual:Number(this.contrato_mensual),
            correos: Number(this.correos),
            codigo_esb: this.codigo_esb,
            documentos_resguardados: Number(this.documentos_resguardados),
            espacio_disponible: Number(this.espacio_disponible),
            estado: this.estado,
            estampado_anual: Number(this.estampado_anual),
            fecha_actualizacion: new Date().toISOString().substr(0, 10),
            flujos: Number(this.flujos),
            manuales: this.manuales,
            nombre: this.nombre,
            id: this.id,
            operadores: Number(this.operadores),
            personalizacion: this.personalizacion,
            plantillas: Number(this.plantillas),
            proceso_lotes: this.proceso_lotes,
            tamano_documentos: Number(this.tamano_documentos),
            tiempo_resguardo: Number(this.tiempo_resguardo),
            usuario_actualizacion: this.$store.state.user.email,
            estampados_ilimitados: this.estampados_ilimitados? "SI" : "NO",
          };
        
          let getuser = axios.put('Plan/Actualizar', vm_data, { 'headers': this.$store.state.user.headers })
          return getuser.then((callback) => {
            if(callback.status == 200 ) {
              this.reset();
              this.$store.dispatch('SHOW_ERROR', {show: true, type: 'success', text: 'Operacion finalizada con éxito.' });
              this.getParametros();
            }
            this.$store.dispatch('UNSET_OVERLAY');
          }).catch((error) => {
            this.es_nueva = false;
            this.dialogForm = true;
            this.$store.dispatch('UNSET_OVERLAY');
            this.$store.dispatch('SHOW_ERROR', {show: true, type: 'error', text: 'Error al realizar la operacion: ' + error.response.data });
            console.log(error.response.data);
          });
        }
      },
   
      crearPlan(){
        this.dialogForm = true;
        this.$refs.form.reset();
      },
      editar(item) {
        console.log("editando:");
        this.dialogForm = true;
        this.es_nueva = false;
        this.selected_id =item.id;

        Object.keys(item).forEach(key => {

           
           this.$set(this, key, item[key]);
           if (key=="estampados_ilimitados" && item[key]=="SI") {
            this.estampados_ilimitados = true;
            console.log(key+"---"+this.estampados_ilimitados);
           } else if (key=="estampados_ilimitados" && item[key]=="NO"){
            this.estampados_ilimitados = false;
           } else if (key=="estampados_ilimitados" && item[key]==null){
            this.estampados_ilimitados = false;
           }
           
        });
      },
      reset() {
        console.log("reset");
        this.es_nueva = true;
        this.dialogForm = false;  
      },
    }
  }
</script>